import { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LoginOverlay from '../LoginOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AppContainer = function AppContainer(_ref) {
  var activeUser = _ref.activeUser,
      loginRequired = _ref.loginRequired,
      light = _ref.light,
      dark = _ref.dark,
      onLoginOverlayClose = _ref.onLoginOverlayClose,
      onMount = _ref.onMount,
      loginOverlayOpen = _ref.loginOverlayOpen,
      onLogIn = _ref.onLogIn,
      children = _ref.children,
      appKey = _ref.appKey;
  useEffect(function () {
    if (typeof onMount === 'function') {
      onMount();
    }
  }, []);

  var renderLoginOverlay = function renderLoginOverlay() {
    if (loginOverlayOpen) {
      return /*#__PURE__*/_jsx(LoginOverlay, {
        onLogin: onLogIn,
        onClose: onLoginOverlayClose,
        opening: true
      });
    } else {
      return null;
    }
  };

  var renderContent = function renderContent() {
    var loginOverlay = renderLoginOverlay();

    if (loginRequired && !activeUser) {
      return /*#__PURE__*/_jsx(LoginOverlay, {
        open: true,
        loginRequired: true,
        onLogin: onLogIn
      });
    } else {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [loginOverlay, children]
      });
    }
  };

  var classes = classNames(appKey, {
    'ptr-light': light || !dark,
    'ptr-dark': dark
  });
  return /*#__PURE__*/_jsx("div", {
    id: "ptr-app",
    className: classes,
    children: renderContent()
  }, "ptr-app");
};

AppContainer.propTypes = {
  appKey: PropTypes.string,
  activeUser: PropTypes.object,
  loginRequired: PropTypes.bool,
  light: PropTypes.bool,
  dark: PropTypes.bool,
  onLoginOverlayClose: PropTypes.func,
  onMount: PropTypes.func,
  children: PropTypes.node,
  loginOverlayOpen: PropTypes.bool,
  onLogIn: PropTypes.func
};
export default AppContainer;